export default {
  recomendedGlueAmount(state, getters) {
    let factor = state.untergrund.secondarySelection?.factor || 0;

    return Number(getters.roofArea * factor)
      .toFixed(2)
      .replace(".", ",");
  },

  roofArea(state) {
    return (Number(state.abmessungen.width) + (Number(state.abmessungen.addedWidth) / 100)) * (Number(state.abmessungen.depth) + (Number(state.abmessungen.addedDepth) / 100));
  },

  dachbahnPrefix(state) {
    return state.gebaeudeart.secondarySelection?.variantNumberPrefix;
  },

  gluePrefix(state) {
    return state.untergrund.secondarySelection?.variantNumberPrefix;
  },

  glueVariations(state, getters) {
    let glueVariations = getters.variations.filter((variation) => variation.number.includes(`${getters.gluePrefix}-`));

    // Filter out products that are not glue, meaning which do not have units in liters (unitId = 5) or milliliters (53)
    glueVariations = glueVariations.filter((variation) => [53, 5].includes(Number(variation.unit.unitId)));

    // Sort by unit content (e.g. '2' when its set to 2 Liter)
    glueVariations.sort((a, b) => {
      let aUnit = Number(a.unit.content);
      let bUnit = Number(b.unit.content);

      if (a.unit.unitId == 53) aUnit = aUnit / 1000; // If is milliliter, convert to liter
      if (b.unit.unitId == 53) bUnit = aUnit / 1000; // If is milliliter, convert to liter

      if (aUnit < bUnit) return -1;
      if (aUnit > bUnit) return 1;
      return 0;
    });

    return glueVariations;
  },

  dachbahnVariations(state, getters) {
    return getters.variations
      .filter((variation) => variation.number.includes(`${getters.dachbahnPrefix}-`))
      .filter((option) => !option.isMain);
  },

  dachrandVariations(state, getters) {
    let prefixes = state.dachraender.randProfilOptions.map((option) => option.prefix);
    
    return getters.variations
      .filter((variation) => variation.number.includes(`${prefixes[0]}`) || variation.number.includes(`${prefixes[1]}`))
      .filter((option) => !option.isMain);
  },

  variations(state) {
    let variations = [];

    state.zusammenstellung.items
      .map((item) => {
        return item.variations.map((variation) => {
          variation.texts = item.texts;
          return variation;
        });
      })
      .forEach((arrayOfVariations) => (variations = [...variations, ...arrayOfVariations]));

    return variations;
  },
};
